import { render } from "./PopUpMsg.vue?vue&type=template&id=5a94a769&scoped=true"
import script from "./PopUpMsg.vue?vue&type=script&lang=js"
export * from "./PopUpMsg.vue?vue&type=script&lang=js"

import "./PopUpMsg.vue?vue&type=style&index=0&id=5a94a769&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a94a769"]])

export default __exports__